import Typography from '@components/basics/typography';
import Flex from '@components/layout/flex';
import React from 'react';

import styled from 'styled-components';

interface Props {
  className?: string;
  colors: string[];
}

export const MerchProductColorSelect = ({
  className,
  colors = [],
}: Props): JSX.Element => {
  return (
    <Flex className={className} justifyContent="flex-end" alignItems="center">
      {colors.map((color, index) => {
        const colorsAmount = 5;
        const numberToDisplay = colors.length - colorsAmount;
        return index < colorsAmount ? (
          <CircleColor
            key={color}
            className={color === '#FFFFFF' ? 'grey-border' : ''}
            color={color}
          />
        ) : index === colorsAmount && numberToDisplay !== 0 ? (
          <AdditionalColors key={color} number={numberToDisplay} />
        ) : null;
      })}
    </Flex>
  );
};

const AdditionalColors = ({ number }: { number: number }) => {
  return (
    <Typography type="smaller" weight="400">
      +{number}
    </Typography>
  );
};

const CircleColor = styled.div`
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.differentBackground};
  height: 10px;
  width: 10px;
  background-color: ${({ color }) => color};
  margin-left: -5px;

  &.grey-border {
    border-color: ${({ theme }) => theme.colors.secondary};
  }
`;
